export default __webpack_public_path__ + "4c452012911dc6d3f7203d56b8a80544.svg";